import * as React from "react";

function MonthStatusLabel({ userApprovalStatus }) {
  switch (userApprovalStatus as CommissionApprovalState) {
    case "not_ready_for_approval":
      return (
        <span className="label label-default">Not Ready for Approval</span>
      );
    case "ready_for_approval":
      return <span className="label label-info">Ready for Approval</span>;
    case "approved":
      return <span className="label label-success">Approved</span>;
    case "needs_review":
      return <span className="label label-warning">Needs Review</span>;
    default:
      return <></>;
  }
}

export default MonthStatusLabel;



// WEBPACK FOOTER //
// ./app/javascript/components/commission_calculator/MonthStatusLabel.tsx